import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Loading Overlay Component
export const LoadingOverlay = ({ state, title, message }: { state: string; title?: string; message?: string }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
    >
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {title || t(`coach.loading.title.${state}`)}
        </h2>
        <p className="text-gray-600">{message || t(`coach.loading.message.${state}`)}</p>
      </div>
    </motion.div>
  );
};
